
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

type ItineraryRequestFiltersProps = {
  selectedStatus: string | null;
  onStatusChange: (status: string | null) => void;
  onRefresh: () => void;
  isRefreshing: boolean;
};

export function ItineraryRequestFilters({
  selectedStatus,
  onStatusChange,
  onRefresh,
  isRefreshing
}: ItineraryRequestFiltersProps) {
  return (
    <div className="mt-4 flex flex-wrap gap-2 md:mt-0">
      <Button 
        variant={selectedStatus === null ? "default" : "outline"}
        onClick={() => onStatusChange(null)}
      >
        All
      </Button>
      <Button 
        variant={selectedStatus === "new" ? "default" : "outline"}
        onClick={() => onStatusChange("new")}
      >
        New
      </Button>
      <Button 
        variant={selectedStatus === "in-progress" ? "default" : "outline"}
        onClick={() => onStatusChange("in-progress")}
      >
        In Progress
      </Button>
      <Button 
        variant={selectedStatus === "converted" ? "default" : "outline"}
        onClick={() => onStatusChange("converted")}
      >
        Converted
      </Button>
      <Button 
        variant={selectedStatus === "declined" ? "default" : "outline"}
        onClick={() => onStatusChange("declined")}
      >
        Declined
      </Button>
      <Button
        variant="outline"
        onClick={onRefresh}
        disabled={isRefreshing}
        className="ml-2"
      >
        {isRefreshing ? (
          <>
            <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
            Refreshing...
          </>
        ) : (
          <>
            <RefreshCw className="mr-2 h-4 w-4" />
            Refresh
          </>
        )}
      </Button>
    </div>
  );
}
